import { Dispatch, SetStateAction } from 'react';
import Icon from '@common/assets';
import { PageState } from '@domain/rs/common/PageableRs';
import PagingNumber from './pagingNumber';

import classnames from 'classnames/bind';
import styles from './pagination.module.scss';
const cx = classnames.bind(styles);

interface Props {
  pagesVO: PageState | null;
  currentPage: number;
  setCurrentPage: Dispatch<SetStateAction<number>>;
  isLeftOn?: boolean;
  isRightOn?: boolean;
  className?: string;
}

const Pagination = ({ pagesVO, currentPage, setCurrentPage, isLeftOn, isRightOn, className }: Props) => {
  const handlePagingClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (event.currentTarget.rel === 'prev') {
      if (!isLeftOn) return;
      setCurrentPage(currentPage - 1);
    } else if (event.currentTarget.rel === 'next') {
      if (!isRightOn) return;
      setCurrentPage(currentPage + 1);
    } else {
      setCurrentPage(Number(event.currentTarget.text) - 1);
    }
  };

  return (
    <div className={cx('pagingArea', className)}>
      <a className={cx('arrow', { on: isLeftOn })} role="button" rel="prev" onClick={handlePagingClick}>
        <Icon name="largeArrowLeftLight" width={24} height={24} />
      </a>
      <PagingNumber
        isEmpty={pagesVO === null || pagesVO.totalElements === 0}
        currentPage={currentPage}
        totalPageNum={pagesVO?.totalPages ?? 1}
        handlePagingClick={handlePagingClick}
      />
      <a className={cx('arrow', { on: isRightOn })} role="button" rel="next" onClick={handlePagingClick}>
        <Icon name="largeArrowRightLight" width={24} height={24} />
      </a>
    </div>
  );
};

export default Pagination;
